// Canonical Tinkr brand, mirrored from apps/web/src/lib/brand.ts. The checkout app
// renders the real splash logo (copied into public/brand/), NOT a text wordmark.

export const BRAND = {
  name: "Tinkr",
  legalName: "Tinkr App Ltd",
  companyNumber: "17142710",
  registeredJurisdiction: "England and Wales",
  registeredOffice: "71-75 Shelton Street, Covent Garden, London WC2H 9JQ, UK",
  supportEmail: "support@tinkrapp.com",
  marketingUrl: "https://tinkrapp.com",
  logos: {
    // The composed lockup that visibly reads "Tinkr"; renders identically when
    // embedded via <img> because the wordmark is outlined paths (no page font).
    fullColorHorizontal: "/brand/tinkr-logo/text-logo-color.svg",
    fullColorMark: "/brand/tinkr-logo/logo-color.svg"
  }
} as const;
